export default __webpack_public_path__ + "static/media/register.7cc884da.svg";